<template>
  <el-dialog custom-class="predict-result-container dialog-size-large"
             title="適用結果"
             visible="true"
             append-to-body="true"
             :top="0"
             :modal="false"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="predict-result-container-inner">
      <fixed-header-table class="predict-result-overview" :fixed="true">
        <tr slot="header">
          <th>適用データ</th>
          <th>モデル名</th>
          <th style="flex-grow: 0; min-width: 120px;">適用日</th>
          <th style="flex-grow: 0; min-width: 120px;">件数</th>
        </tr>
        <tr>
          <td>{{uploadFileName}}</td>
          <td>{{modelName}}</td>
          <td style="flex-grow: 0; min-width: 120px;">{{predictResult.updatedAt | date_format('YYYYMMDDHHmmss',
            'YYYY/MM/DD')}}
          </td>
          <td style="flex-grow: 0; min-width: 120px;">{{predictResult.resultCount | number_format}}</td>
        </tr>
      </fixed-header-table>
      <h3 style="margin-top: 16px; flex-shrink: 0;">結果のプレビュー</h3>
      <fixed-header-table
              :fixed="predictResult.resultPreview.results != null && predictResult.resultPreview.results.length > 0"
              style="max-height: 310px;">
        <tr slot="header">
          <th>{{predictResult.resultPreview.idName}}</th>
          <th v-for="header in predictResult.resultPreview.header">{{header}}</th>
        </tr>
        <tr v-for="result in predictResult.resultPreview.results">
          <td>{{result.id}}</td>
          <td v-for="header in predictResult.resultPreview.header">{{formatNumberCell(result, header)}}</td>
        </tr>
      </fixed-header-table>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <a :href="predictResult.resultFile">
        <el-button type="info" class="large" style="width: 320px; height: 50px;">結果をダウンロード</el-button>
      </a>
    </div>
  </el-dialog>
</template>

<script>
import { PredictResult } from '../../../../defines/model/model'
import FormatUtil from '../../../../utils/format'

export default {
  name: 'PredictResultDialog',
  components: {},
  props: {
    modelName: '',
    uploadFileName: '',
    predictResult: PredictResult
  },
  methods: {
    formatNumberCell (row, column) {
      for (let val of row.value) {
        if (val['name'] === column) {
          return FormatUtil.formatNumber(val['value'], '-')
        }
      }
      return ''
    }
  }
}

</script>

<style scoped>
  .predict-result-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .predict-result-overview.table-wrapper.fixed {
    border-bottom: none;
    border-right: none;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .predict-result-overview.table-wrapper.fixed >>> .table-header > thead {
    padding-right: 0;
  }

  .predict-result-overview.table-wrapper.fixed >>> .table-body {
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/predict/dialogs/predict-result.vue